import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    color: "#00A4B3", // Consistent purple color for the thumb
    padding: 1,
    "&$checked": {
      color: "#00A4B3", // Keep thumb purple when checked
      transform: "translateX(16px)", // Move thumb when checked
      "& + $track": {
        backgroundColor: "#00A4B3", // Keep track purple when checked
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#00A4B3",
    },
  },
  thumb: {
    width: 24,
    height: 24,
    color: theme.palette.common.white, // Keep thumb white
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.common.white}`, // Keep white border
    backgroundColor: "#00A4B3", // Keep track purple
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {}, // No need for specific color changes
  focusVisible: {
    border: "6px solid #fff",
  },
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function CustomSwitch(props) {
//   const isChecked = useSelector(
//     (store) => store.gstr2a2bNewCommonReducer.isChecked
//   );
//   const loaderStatus = useSelector(
//     (store) => store.gstr2a2bNewFetchReducer.loaderStatus
//   );
//   useEffect(() => {
//     console.log("isChecked::", isChecked);
//   }, [isChecked]);
  return (
    <FormGroup>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography style={{ fontWeight: "500" }}>Case Wise</Typography>
        <IOSSwitch />
        <Typography style={{ fontWeight: "500" }}>Note Wise</Typography>
      </div>
    </FormGroup>
  );
}
